// সাইটগুলোর ঠিকানা এক জায়গায়। README-র "URL: সাইট বনাম অ্যাপ" দেখুন:
//   অ্যাপ  = মুমতাহিন অ্যাপ (যেখানে পেপার বানানো হয়, আর "কপি করুন" বাটন যেখানে যায়)
//   সাইট  = প্রচারের/ল্যান্ডিং সাইট (প্রাইভেসি, শর্তাবলী)
export const APP_URL = (import.meta.env.VITE_MUMTAHIN_APP_URL ?? "https://mumtahin.pages.dev").replace(/\/+$/, "");
export const SITE_URL = "https://mumtahin.web.app";
export const GALLERY_URL = "https://mumtahin-gallery.pages.dev";
